import { WSPage } from "@wingspanhq/fe-component-library";
import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { MyResourcesTab } from "../types";
import { PARAMETER_MY_RESOURCE_ID, PARAMETER_TAB } from "../paths";
import { useQueryInsuranceCoverage } from "../../../query/insuranceCoverage/queries/useQueryInsuranceCoverage";
import { WSQueries } from "../../../query/WSQuery";
import { PlanEnrollmentDetails } from "./PlanEnrollmentDetails";
import { InsuranceImportDetails } from "./InsuranceImportDetails";

type Props = RouteComponentProps<{
  [PARAMETER_TAB]?: MyResourcesTab;
  [PARAMETER_MY_RESOURCE_ID]: string;
}>;

export const RouteMyResourceDetails: React.FC<Props> = ({ match, history }) => {
  const qInsuranceCoverage = useQueryInsuranceCoverage(
    match.params.myResourceId
  );

  return (
    <WSPage colorBackground="gray50">
      <WSQueries queries={{ qInsuranceCoverage }}>
        {({ qInsuranceCoverageData }) => {
          if (qInsuranceCoverageData.sourceType === "PlanEnrollment") {
            return (
              <PlanEnrollmentDetails
                tab={match.params.tab}
                insuranceCoverage={qInsuranceCoverageData}
              />
            );
          } else if (qInsuranceCoverageData.sourceType === "InsuranceImport") {
            return (
              <InsuranceImportDetails
                insuranceCoverage={qInsuranceCoverageData}
                tab={match.params.tab}
              />
            );
          }
        }}
      </WSQueries>
    </WSPage>
  );
};
